export const _setTrackerStatus = (state, action) => action.payload;
